import { Action } from "redux";
import { isAccommodationAction } from "./Accommodation.js";
import { isAlertsAction } from "./Alerts.js";
import { isColorSchemesAction } from "./ColorSchemes.js";
import { isFontsAction } from "./Fonts.js";
import { isIssuesAction } from "./Issues.js";
import { isKeyboardAction } from "./Keyboard.js";
import { isLanguagesAction } from "./Languages.js";
import { isLegalNavAction } from "./LegalNav.js";
import { isLinkSelectAction } from "./LinkSelect.js";
import { isLoadStateAction } from "./LoadStates.js";
import { isLoginAction } from "./Login.js";
import { isLogosAction } from "./Logos.js";
import { isMediaLibraryAction } from "./MediaLibrary.js";
import { isModulesAction } from "./Modules.js";
import { isPagesAction } from "./Pages.js";
import { isPartnersAction } from "./Partners.js";
import { isPricesAction } from "./Prices.js";
import { isPublishAction } from "./Publish.js";
import { isRevisionsAction } from "./Revisions.js";
import { isRichEditorAction } from "./RichEditor.js";
import { isRoomsAction } from "./Rooms.js";
import { isSeoAction } from "./Seo.js";
import { isSitesAction } from "./Sites.js";
import { isSpecialsAction } from "./Specials.js";
import { isStoreAction } from "./Store.js";
import { isUserAction } from "./User.js";

export const isAnyAction = (action: Action) => {
  return (
    isAccommodationAction(action) ||
    isAlertsAction(action) ||
    isColorSchemesAction(action) ||
    isFontsAction(action) ||
    isLanguagesAction(action) ||
    isLegalNavAction(action) ||
    isLinkSelectAction(action) ||
    isLoginAction(action) ||
    isLogosAction(action) ||
    isPartnersAction(action) ||
    isMediaLibraryAction(action) ||
    isModulesAction(action) ||
    isPagesAction(action) ||
    isPublishAction(action) ||
    isRichEditorAction(action) ||
    isRoomsAction(action) ||
    isPricesAction(action) ||
    isSitesAction(action) ||
    isSpecialsAction(action) ||
    isUserAction(action) ||
    isStoreAction(action) ||
    isRevisionsAction(action) ||
    isSeoAction(action) ||
    isLoadStateAction(action) ||
    isKeyboardAction(action) ||
    isIssuesAction(action)
  );
};
